define('views/modules/setting/business/blocks/custom-exercise-names',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // collections
    'collections/calendar/session/renamed-animations',
    // views
    'views/parts/info-section',
    'views/modules/calendar/animated-session/animation/rename/custom-names-manager-panel',
    // templates
    'text!templates/modules/setting/business/blocks/custom-exercise-names.html'

], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    // collections
    CRenamedAnimations,
    // views
    VInfoSection,
    VCustomNamesManagerPanel,
    // templates
    TCustomExerciseNames
) {

    var VCustomExerciseNames = Backbone.Epoxy.View.extend({
        template: TCustomExerciseNames,
        regions: {
            count: '.count',
            datas: '.datas'
        },

        initialize: function(opt) {
            this.group = opt.group;
            this.url = opt.url;

            this.collection = new CRenamedAnimations(null, {
                group: this.group.id
            });

            this.view = {
                info: new VInfoSection({
                    title: "Your custom exercise names",
                    icon: "sl-icon-settings",
                    //help: "messages:helpbox-business-custom-exercises-names-view",
                    buttonBottom: {
                        text: "Manage my custom exercise names",
                        context: this,
                        callback: this.onManageCustomExerciseNames
                    },
                    content: this.template,
                }),
            };

            this.listenTo(this.collection, { "sync": this.onCollectionSync });
        },

        render: function() {
            this.assign(this.view.info, this.$el) // must be first
                .applyBindings();

            this.generateZones();

            this.collection.fetch();

            return this;
        },

        _renderCount: function() {
            this.zone.$count.html(this.collection.length);
        },

        _renderData: function() {
            this.zone.$datas.html(this.collection.getStringNames());
        },

        ////////////
        // events //
        ////////////

        onManageCustomExerciseNames: function(e) {
            e.preventDefault();
            var view = this.view,
                panel = view.manager || (view.manager = new VCustomNamesManagerPanel({ group: this.group }));
            this.trigger('panel:stack', panel);
        },

        onCollectionSync: function(collection, options) {
            this._renderData();
            this._renderCount();
        },

    });

    return VCustomExerciseNames;
});

